@use './inputs-mixin' as input;
@use './shared';

:host {
    @include input.rootProperties();
    display: block;
}

@each $size, $props in shared.$sizes {
    :host(#{input.$CLASS}--#{$size}) {
        --input-height: #{map-get($props, "height")};
        --input-radius: #{map-get($props, "radius")};
        --input-padding: #{map-get($props, "padding")};
        --input-font-size: #{map-get($props, "font-size")};
        --input-unit-height: #{map-get($props, "unitHeight")};
    }
}

#{input.$CLASS} {
    @include input.commonStyle();
    @include input.passwordIcon();
    @include input.wrapperStyle();
    @include input.unitContent();
    @include input.disabledState();
    @include input.invalidState();

    &--wrapper---clearable {
        input {
            padding-right: var(--joy-core-spacing-10);
        }
    }

    &--clear {
        cursor: pointer;
        position: absolute;
        top: 50%;
        z-index: 2;
        right:  var(--joy-core-spacing-5);
        transform: translateY(-50%);
    }
}




